import '../../../common-assets/styles/pages/sell-ad.scss';
import '../../../common-assets/styles/external/all.min.css';

import { checkSellAdFields } from '../../../common-assets/js/components/sell_ad';

$(function () {
    let $body = $('body');

    $body.on('click', '#sellAdValue', function () {
        checkSellAdFields.transferOma('car');
    });

    // verified ad button click event
    $body.on('click', '#sellVerifiedAd', function () {
        checkSellAdFields.displayVerifiedAdForm();
    });

    // verified ad continue button click event
    $body.on('click', '#processVerifiedAd', function () {
        checkSellAdFields.processVerifiedAd('car');
    });

    // verified ad link click event
    $body.on('click', '#verifiedAdLink', function () {
        $('html, body').animate(
            {
                scrollTop: $('.verifiedRegisterNumber').offset().top,
            },
            100
        );
        checkSellAdFields.displayVerifiedAdForm();
    });

    // Show/hide sections in mobile view
    $body.on('click', '#verifiedAdSection', function () {
        checkSellAdFields.toggleSellVehicleSections('verifiedAdSectionDiv', 'verifiedAdSection');
    });

    // Show/hide sections in mobile view
    $body.on('click', '#basicAdSection', function () {
        checkSellAdFields.toggleSellVehicleSections('basicAdSectionDiv', 'basicAdSection');
    });
    $body.on('click', '.sellVehicleTitle', function () {
        checkSellAdFields.showHideFaqPara(this);
    });

    $body.on('click', '#recommendedSellingMethod', function () {
        const siteCode = $(this).data('sitecode'); // Get data-sitecode from the element
        checkSellAdFields.recommendSellingMethod(siteCode);
    });
});
